const ClientProfilerInterface = require('@zillow/client-profiler-interface-cs');

const beacon = (...args) => ClientProfilerInterface.beacon(...args);
const profileIntervalFail = (...args) => ClientProfilerInterface.profileIntervalFail(...args);
const registerEvent = (...args) => ClientProfilerInterface.registerEvent(...args);
const registerEvents = (...args) => ClientProfilerInterface.registerEvents(...args);
const registerPage = (...args) => ClientProfilerInterface.registerPage(...args);
const profile = (...args) => ClientProfilerInterface.profile(...args);
const profileIntervalBegin = (...args) => ClientProfilerInterface.profileIntervalBegin(...args);
const profileIntervalEnd = (...args) => ClientProfilerInterface.profileIntervalEnd(...args);

module.exports = {
    beacon,
    profileIntervalFail,
    registerEvent,
    registerEvents,
    registerPage,
    profile,
    profileIntervalBegin,
    profileIntervalEnd,
};
